module.exports = __webpack_public_path__ + "img/boxed-15.a4f8c773.jpg";